import RelationshipMetadata from "../../RelationshipMetadata";

class ProjectPlanPhaseMilestoneProjectPlanPhaseMilestoneEmployeeRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "ProjectPlanPhaseMilestoneProjectPlanPhaseMilestoneEmployee";
        this.parentEnterpriseComponent = "ProjectPlanPhaseMilestone";
        this.childEnterpriseComponent = "ProjectPlanPhaseMilestoneEmployee";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "ProjectPlanPhaseMilestoneUSID";
    }
}

export default ProjectPlanPhaseMilestoneProjectPlanPhaseMilestoneEmployeeRelationshipMetadata;